/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import { Route, Switch, BrowserRouter} from 'react-router-dom'
import { PATHS } from '../../../global/constants'
import MyCollections from './myCollections'
import ListenCollection from './listenCollection'
import ReadCollection from './readCollection'
import SpeakCollection from './speakCollection'
import WriteCollection from './writeCollection'

export default function CollectionRoute() {
  return (
    <BrowserRouter>
    <Switch>
      <Route path={PATHS.admin.name+PATHS.myCollections.name} exact component={MyCollections}/>
      <Route path={PATHS.admin.name+PATHS.myCollections.listenCollect.name} component={ListenCollection}/>
      <Route path={PATHS.admin.name+PATHS.myCollections.readCollect.name} component={ReadCollection}/>
      <Route path={PATHS.admin.name+PATHS.myCollections.writeCollect.name} component={WriteCollection}/>
      <Route path={PATHS.admin.name+PATHS.myCollections.speakCollect.name} component={SpeakCollection}/>
    </Switch>
    </BrowserRouter>
  )
}
